<template>
  <div />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import utility from '@/utilities/utility'
export default {
  name: 'PaymentCallback',
  computed:
  {
    ...mapGetters({
      paymentTransaction: 'order/paymentTransaction'
    })
  },
  methods: {
    ...mapActions({
      getPaymentTransaction: 'order/getPaymentTransaction'
    }
    ),
    redirectToCallback () {
      if (this.isSuccessfulPayment()) {
        let transactionId = utility.getQueryStringValue('transactionId')
        let input = {
          transactionId: transactionId
        }
        this.getPaymentTransaction(input).then(response => {
          if (response.transactionRequestMode === 'Charge') {
            this.$router.push({ path: 'successfulChargeWalletPayment' })
          }
          if (response.transactionRequestMode === 'ChargeAndPay') {
            this.$router.push({ path: 'successfulSubscriptionPayment' })
          }
          if (response.transactionRequestMode === 'Pay') {
            this.$router.push({ path: 'successfulSubscriptionPayment' })
          }
        })
      } else {
        this.$router.push({ path: 'failedPayment' })
      }
    },
    isSuccessfulPayment () {
      let status = utility.getQueryStringValue('status')
      let successful = status === 'Success'
      return successful
    }
  },
  created () {
    this.redirectToCallback()
  }
}
</script>
